import { classNames } from '@vkontakte/vkjs';
import { Div, DivProps } from '@vkontakte/vkui';
import styles from './DivX.module.css';

export function DivX(props: DivProps) {
  const { className, ...rest } = props;

  return <Div className={classNames(styles.root, className)} {...rest} />;
}
